import Businesses from './Businesses.page';

export default Businesses;
